import styled, { css } from 'styled-components';
import { TOP_BAR_HEIGHT } from './TopBar.constants';

export const Shell = styled.header<{ $bordered?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: ${TOP_BAR_HEIGHT}px;
  padding: 14px 16px 14px 28px;
  gap: ${({ theme: { spacing } }) => spacing?.level4 ?? '12px'};
  box-sizing: border-box;

  ${({ theme: { colors = {} } }) => css`
    background: ${colors.surface ?? 'transparent'};
    color: ${colors.onSurface ?? 'inherit'};
  `}

  ${({ $bordered, theme: { colors = {} } }) =>
    $bordered &&
    css`
      border-bottom: 1px solid
        ${colors.shellDivider ?? colors.outlineVariant ?? 'rgb(255 255 255 / 0.08)'};
    `}
`;

export const LeftSlot = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: ${({ theme: { spacing } }) => spacing?.level3 ?? '8px'};
  flex: 1 1 auto;
`;

/**
 * Title sits on the left and reads as a small label, NOT a hero heading —
 * the page's content header lives below the bar. The 14/600 size matches
 * the prototype's `.home__topbar-title`.
 */
export const Title = styled.h1`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurface ?? 'inherit'};
  `}
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { spacing } }) => spacing?.level3 ?? '8px'};
  flex: 0 0 auto;
`;
